import { useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';
import { Button } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import { VerifyNewBankAccountModal } from '../../../../modals/addPaymentMethodModal/linkBankAccount/verifyNewBankAccountModal/VerifyNewBankAccountModal';
import StepItem from '../../stepItem/StepItem';

export const VerifyNewBankAccount = ({
    triggerRefetchFundingRequirements
}: {
    triggerRefetchFundingRequirements: () => void;
}) => {
    const [
        verifyNewBankAccountModalIsOpen,
        setVerifyNewBankAccountModalIsOpen
    ] = useState(false);

    return (
        <>
            <VerifyNewBankAccountModal
                isModalOpen={verifyNewBankAccountModalIsOpen}
                onClose={() => {
                    setVerifyNewBankAccountModalIsOpen(false);
                    triggerRefetchFundingRequirements();
                }}
            />
            <StepItem
                title={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.verify_new_bank_account_title"
                        defaultMessage="Verify your new business account"
                    />
                }
                caption={
                    <FormattedMessage
                        id="_.funding_requirements.add_bank_details.verify_new_bank_account_subtitle"
                        defaultMessage="Thanks for adding your account. Please verify that it's a business account and that you are the account holder."
                    />
                }
                action={
                    <Button
                        variant="primary"
                        onClick={() => {
                            tracking.ampli.addBankDetailsVerifyNewAccount();
                            setVerifyNewBankAccountModalIsOpen(true);
                        }}
                    >
                        <FormattedMessage
                            id="_.funding_requirements.add_bank_details.verify_new_bank_account_button"
                            defaultMessage="Verify now"
                        />
                    </Button>
                }
            />
        </>
    );
};
